module.exports = __webpack_public_path__ + "img/MEDIA112.4b26ce5b.jpg";